/** Finds initial (assumed primary) darwin dealer ID and checks against 
 * remaining ID's from given `user.accountList`
 * 
 * @param {{darwinDealerId?: string, [key:string]: any}} accountList 
 * @returns {boolean}
 */
function hasMultiDarwinDealerIds (accountList=[]) {
    try {
      const darwinDealerId = accountList ? accountList.find(acct => acct.darwinDealerId)?.darwinDealerId : '';
      const multiDealerIds = accountList.some(acct => acct?.darwinDealerId && acct.darwinDealerId !== darwinDealerId);
      return multiDealerIds;
    } catch (parseDealerError) {
      console.error(' Error finding multi darwin dealer ID(s) ', parseDealerError?.message || parseDealerError);
      return false;
    }
}

/** Checks initial darwin dealer ID exists in account(s) from given `user.accountList`
 * 
 * @param {{darwinDealerId?: string, [key:string]: any}} accountList 
 * @returns {boolean}
 */
function hasDarwinDealerIds (accountList=[]) {
    try {
      const hasId = accountList.some(acct => acct.darwinDealerId);
      return hasId;
    } catch (parseDealerError) {
      console.error(' Error finding darwin dealer ID(s) ', parseDealerError?.message || parseDealerError);
      return false;
    }
  }

export {hasDarwinDealerIds, hasMultiDarwinDealerIds};